import React, { useState, useEffect } from 'react';
import {Fator}  from './style';
import {BrowserRouter as Router, Switch, Route, Link} from "react-router-dom";


function Foot (props) {
    return(
        <div>
        <Fator>
            You have seen Tain nude {props.num} times
        </Fator>
        <Link to='mission-statement' style={{textDecoration: 'none', color: 'black'}}> 
        <Fator>
            Mission Statement
        </Fator>
        </Link>
        <Link to='missing-statement' style={{textDecoration: 'none', color: 'black'}}> 
        <Fator>
            Missing Statement
        </Fator>
        </Link>
        <Link to='dice-roll' style={{textDecoration: 'none', color: 'black'}}> 
        <Fator>
            Dice Roll
        </Fator>
        </Link>
        </div>
    )
}

export default Foot;